module.exports = __webpack_public_path__ + "img/credit-card-light.e6a5c18d.svg";